import OktaAuth from '@okta/okta-auth-js';
export var oktaInstances = [];

if (process.env.REACT_APP_OKTA_CLIENT_ID) {
  oktaInstances.push({
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    domain: process.env.REACT_APP_OKTA_DOMAIN,
    name: process.env.REACT_APP_OKTA_NAME,
  });
}
if (process.env.REACT_APP_OKTA_CLIENT_ID_2) {
  oktaInstances.push({
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID_2,
    domain: process.env.REACT_APP_OKTA_DOMAIN_2,
    name: process.env.REACT_APP_OKTA_NAME_2,
  });
}

const oktaProvider = JSON.parse(window.localStorage.getItem('oktaProvider'));
let CLIENT_ID;
let OKTA_DOMAIN;
if (oktaInstances.length) {
  CLIENT_ID = oktaInstances[0].clientId;
  OKTA_DOMAIN = oktaInstances[0].domain;
  if (oktaProvider) {
    const index = oktaInstances.findIndex((el) => el.domain === oktaProvider);
    if (oktaInstances[index]) {
      CLIENT_ID = oktaInstances[index].clientId;
      OKTA_DOMAIN = oktaInstances[index].domain;
    }
  }
}

export const BASE_URL = `https://${OKTA_DOMAIN}`;

const REDIRECT_URI = window.location.origin + '/callback';

const scopes = ['openid', 'profile', 'email', 'offline_access'];

export const oktaConfig = {
  clientId: CLIENT_ID,
  issuer: BASE_URL,
  redirectUri: REDIRECT_URI,
  scopes: scopes,
  tokenManager: {
    storageKey: 'gg-token-storage',
  },
  restoreOriginalUri: (oktaAuth, originalUri) => {
    const fallback = '/v3';
    const target = originalUri?.includes(fallback) ? originalUri : fallback;
    window.location.replace(target);
  },
};

export const oktaAuth = new OktaAuth(oktaConfig);
